import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import { useGrantedUser } from "customer/settings/grantedUsers/granted-user.service";
import { localize } from "shared/helpers/utils";
import { mapServerErrors } from "shared/helpers/client";
import { Trans, useTranslation } from "react-i18next";
import _ from "lodash";
import { toast } from "react-toastify";

const InviteByEmail = ({ show, onHide,inviteData }) => {
  const {t} = useTranslation();
  const [serverErrors, setServerErrors] = React.useState({});
  const { inviteUserForm, roles,inviteUserServer,updateUserServer,grantedUserSource } = useGrantedUser(inviteData);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = inviteUserForm;

  const inviteUser = (data) => {
    const inviteDto = {
      "email": data.email,
      "grantedUserRoleTypeId": data.grantedUserRoleTypeId,
      "contactName": data.contactName,
      "jobDescription": data.jobDescription || 0,
      "isActive":data.isActive || false
    }
    if (!_.isEmpty(inviteData)) {
      updateUserServer.mutate({...inviteDto,id:inviteData.id}, {
        onSuccess({ response, error }) {
          if (response) {
            onHide();
            grantedUserSource.load();
            toast.success("Updated Successfully");
          }
        },
      });
    }else{
      inviteUserServer.mutate(inviteDto, {
        onSuccess({ response, error }) {
          if (response) {
            onHide();
            grantedUserSource.load();
            toast.success("Invited Successfully");
          }
        },
      });
    }

  };

  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={onHide}
      className="all-modal newAddress"
    >
      <Modal.Body>
        <div className="header">
          <h1>{t('granted-user.invite_by_email')}</h1>
          <img src={Back} alt="back" onClick={onHide} />
        </div>
        <hr className="hr" />
        <form onSubmit={handleSubmit(inviteUser)} >
          <div className="div-req">
            <div class="form-group row">
              <label for="inputEmail3" class="col-sm-3 col-form-label ">
                <Trans
                  i18nKey="granted-user.email"
                  components={{
                    s: <small className="star-require" />,
                  }}
                />
              </label>
              <div class="col-sm-9">
                <Input
                  readonly={!_.isEmpty(inviteData)}
                  type="text"
                  {...register("email")}
                  error={errors.email?.message ?? serverErrors["Email"]}
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword3" class="col-sm-3 col-form-label">
                <Trans
                  i18nKey="granted-user.role-type"
                  components={{
                    s: <small className="star-require" />,
                  }}
                />
              </label>
              <div class="col-sm-5">
                <Input
                  getOptionLabel={(r) => localize(r.name)}
                  type="select"
                  defaultVal={inviteData? inviteData?.grantedUserRoleTypeId :''}
                  {...register("grantedUserRoleTypeId")}
                  options={roles}
                  error={errors.roleId?.message}
                />
              </div>
            </div>
          </div>
          <div className="div-prim">
            <div class="form-group row">
              <label for="inputEmail3" class="col-sm-3 col-form-label">
                {t('granted-user.contact_name')}
              </label>
              <div class="col-sm-9">
                <Input
                  type="text"
                  {...register("contactName")}
                  error={errors.contactName?.message}
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword3" class="col-sm-3 col-form-label">
                {t('granted-user.job_description')}
              </label>
              <div class="col-sm-9">
                <Input
                  type="text"
                  {...register("jobDescription")}
                  error={errors.jobDescriptionId?.message}
                />
              </div>
            </div>
          </div>
          {!_.isEmpty(inviteData) &&(<div class="form-group row">
              <label for="inputPassword3" class="col-sm-3 col-form-label">
                <Trans
                  i18nKey="status"
                  components={{
                    s: <small className="star-require" />,
                  }}
                />
              </label>
              <div class="col-sm-3">
                <input
                   type="checkbox"
                   {...register("isActive")}
                />
              </div>
            </div>)}
          
          <div class="form-group row pl-24">
            <div className="col-sm-3"></div>
            <div class="col-sm-9 ">
              <div className="row">
                <div className="col-sm-5">
                  <button
                    type="submit"
                    disabled={inviteUserServer.isLoading}
                    className="btn-blue w-100"
                  >
                    <Spinner animation="border" size="sm" hidden={!inviteUserServer.isLoading} />{" "}
                    {t('granted-user.invite')}
                  </button>
                </div>
                <div className="col-sm-5">
                  <button type="button" onClick={onHide} className="btn-border-blue w-100">
                    {t('granted-user.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default InviteByEmail;
